import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GenderIcon } from '../../../core/services/person.service';

@Component({
  standalone: false,
  selector: 'ssc-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonComponent {
  @Input() public icon: GenderIcon | null;
  @Input() public name: string | null;
}
